<template>
  <view-invoices-data />
</template>
<script>
import ViewInvoicesData from "./ViewInvoicesData.vue";
export default {
  name: "view-invoices-page",
  components: {
    ViewInvoicesData
  },
  data() {
    return {};
  }
};
</script>
